import type Trix from 'trix';
import onLoad from '../../../javascripts/utils/onLoad';

onLoad('.richtext', async () => {
  document.querySelectorAll<HTMLInputElement>('input[data-trix-validate-href]').forEach(($input) => {
    $input.name = $input.dataset.name ?? '';
  });

  const { default: trix } = await import(/* webpackChunkName: "trix" */ 'trix') as { default: Trix };

  trix.config.blockAttributes.heading2 = {
    tagName: 'h2',
    terminal: true,
    breakOnReturn: true,
    group: false,
  };

  trix.config.blockAttributes.heading3 = {
    tagName: 'h3',
    terminal: true,
    breakOnReturn: true,
    group: false,
  };

  trix.config.blockAttributes.default = {
    tagName: 'p',
    parse: false,
    breakOnReturn: true,
  };

  trix.Block.prototype.breaksOnReturn = function breaksOnReturn() {
    const attr = this.getLastAttribute();
    const config = trix.config.blockAttributes[attr || "default"];

    return config ? config.breakOnReturn : false;
  };

  trix.LineBreakInsertion.prototype.shouldInsertBlockBreak = function shouldInsertBlockBreak() {
    if (this.block.hasAttributes() && this.block.isListItem() && !this.block.isEmpty()) {
        return this.startLocation.offset > 0;
    }

    return !this.shouldBreakFormattedBlock() ? this.breaksOnReturn : false;
  };
});

document.addEventListener('trix-attachment-add', (event) => {
  event.preventDefault();
});
